import format from 'string-template';
import translation from '../static/translations/index.json';
import {LANGUAGES} from './constants';

class TranslationService {
    private language: string = LANGUAGES.en;

    private subscribers: Array<Function> = [];

    constructor() {
        this.gettext = this.gettext.bind(this);
    }

    public getLanguage(): string {
        return this.language;
    }

    public setLanguage(language: string): void {
        this.language = language;
        this.publish();
    }

    public gettext(message: string, vars?: object): string {
        const translationByLanguage = translation[this.language] || {};
        const translatedMessage = translationByLanguage[message] || message;

        return vars ? format(translatedMessage, vars) : translatedMessage;
    }

    public subscribe(callback: Function): void {
        this.subscribers.push(callback);
    }

    public unsubscribe(callback: Function): void {
        this.subscribers = this.subscribers.filter(subscriber => subscriber !== callback);
    }

    private publish(): void {
        this.subscribers.forEach(subscriber => subscriber());
    }
}

const translationService = new TranslationService();

export default translationService;
// FYI: For ease of use, this method is exported separately from the class (Slava, 05.02.2023)
export const gettext = translationService.gettext; // eslint-disable-line
